import { AutocompleteOption } from 'redesign';
import { DateTime } from 'luxon';
import { formatPaymentStatus } from 'shared/utils/formatting';
import { PaymentsFiltersFormType } from './payments-filters.types';
import { PaymentsFilters } from '../hooks/use-payments-filters.types';
import { paymentStates } from '../payments.types';

export const mapFiltersToPaymentsFilterForm = (
  appliedFilters: PaymentsFilters,
  flexworkerOption: AutocompleteOption | null
): PaymentsFiltersFormType => {
  return {
    creationDate: appliedFilters.creationDate && appliedFilters.creationDate.toFormat('yyyy-MM-dd'),
    allowCreationDateFilter: !!appliedFilters.creationDate,
    dueDate: appliedFilters.dueDate && appliedFilters.dueDate.toFormat('yyyy-MM-dd'),
    allowDueDateFilter: !!appliedFilters.dueDate,
    allowWorkersFilter: !!appliedFilters.workerId,
    worker: flexworkerOption,
    allowInvoiceFilter: !!appliedFilters.invoiceReference,
    invoiceReference: appliedFilters.invoiceReference,
    allowStatusFilter: !!appliedFilters.status,
    status: appliedFilters.status?.map((status) => ({
      id: status,
      name: formatPaymentStatus(status as paymentStates),
    })),
  };
};

export const mapPaymentsFilterFormToFilters = (data: PaymentsFiltersFormType): PaymentsFilters => {
  return {
    creationDate:
      data.allowCreationDateFilter && data.creationDate
        ? DateTime.fromFormat(data.creationDate, 'yyyy-MM-dd')
        : undefined,
    workerId: (data.allowWorkersFilter && data.worker?.value) || undefined,
    invoiceReference: data.allowInvoiceFilter ? data.invoiceReference : undefined,
    status: data.allowStatusFilter ? data.status?.map((status) => status.id) : undefined,
    dueDate:
      data.allowDueDateFilter && data.dueDate
        ? DateTime.fromFormat(data.dueDate, 'yyyy-MM-dd')
        : undefined,
  };
};
